import {keyFormat} from "../../features/ValueFormater";

const RenderKeyValuePairs = ({obj}) => {
    return Object.entries(obj).map(([key, value]) => {
        const formattedKey = keyFormat(key);
        return (
            <>
                {
                    key !== "IsAutoExchangeOn" &&
                    <div className="row rowCont" key={key}>
                        <div className="col-2 subTitle">{formattedKey}</div>
                        <div className="col-9 desc">{value}</div>
                    </div>
                }
            </>
        );
    });
};

export default RenderKeyValuePairs;